module.exports = __webpack_public_path__ + "img/9.2ece48a1.jpg";